import React from 'react';
import { GlobalStyles as MuiGlobalStyles } from '@mui/material';
import MarkProFont from '../main/assets/fonts/MarkPro.woff2';

const GlobalStyles = () => (
  <MuiGlobalStyles
    styles={{
      '@font-face': {
        fontFamily: 'MarkPro',
        src: `url(${MarkProFont}) format('woff2')`,
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontDisplay: 'swap',
      },
      'body': {
        background: 'radial-gradient(ellipse at top right, #0C0E6B 0%, transparent 50%), #060621',
        backgroundAttachment: 'fixed',
        minHeight: '100vh',
      },
    }}
  />
);

export default GlobalStyles;